// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"s5-z","displaySixCardTiles":"t5-z"};